"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.object.assign.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FlatButton = _interopRequireDefault(require("material-ui/FlatButton"));

var _RaisedButton = _interopRequireDefault(require("material-ui/RaisedButton"));

var _Card = require("material-ui/Card");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

require('../../../sass/components/shared/elements/PopupDialog.css');

function actionButtons(action, idx, _ref) {
  var length = _ref.length;
  return /*#__PURE__*/_react.default.createElement(_FlatButton.default, _extends({
    key: idx
  }, action, {
    style: {
      minWidth: 'auto',
      marginRight: idx + 1 === length ? 0 : '8px'
    },
    labelStyle: {
      fontSize: '1.6rem',
      textTransform: 'none'
    }
  }));
}

var PopupDialog = /*#__PURE__*/function (_React$Component) {
  _inherits(PopupDialog, _React$Component);

  var _super = _createSuper(PopupDialog);

  function PopupDialog(props) {
    var _this;

    _classCallCheck(this, PopupDialog);

    _this = _super.call(this, props);
    _this.state = {
      expanded: props.expanded
    };
    return _this;
  }

  _createClass(PopupDialog, [{
    key: "makeStack",
    value: function makeStack(stackTrace) {
      return /*#__PURE__*/_react.default.createElement(_Card.CardText, {
        expandable: true
      }, /*#__PURE__*/_react.default.createElement("textarea", {
        className: "stack"
      }, stackTrace), /*#__PURE__*/_react.default.createElement(_RaisedButton.default, {
        onClick: function onClick() {
          var copyTextarea = document.querySelector('.stack');
          copyTextarea.select();

          try {
            document.execCommand('copy');
          } catch (err) {
            console.error(err);
          }
        }
      }, "Copy to Clipboard"));
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "backdrop",
        style: props.backdropStyle
      }, /*#__PURE__*/_react.default.createElement(_Card.Card, {
        className: "popup-dialog",
        style: props.dialogStyle
      }, /*#__PURE__*/_react.default.createElement(_Card.CardHeader, {
        title: props.title,
        style: {
          paddingBottom: 0
        },
        className: "popup-header",
        actAsExpander: props.actAsExpander,
        showExpandableButton: props.showExpandableButton
      }), /*#__PURE__*/_react.default.createElement(_Card.CardText, {
        className: "popup-text",
        color: "#757575"
      }, props.children), props.stackTrace && this.makeStack(props.stackTrace), props.actions && props.actions.length && /*#__PURE__*/_react.default.createElement(_Card.CardActions, {
        style: {
          display: 'flex',
          justifyContent: 'flex-end'
        }
      }, props.actions.map(actionButtons))));
    }
  }]);

  return PopupDialog;
}(_react.default.Component);

exports.default = PopupDialog;
PopupDialog.propTypes = {
  expanded: _propTypes.default.bool,
  expandOn: _propTypes.default.bool,
  actAsExpander: _propTypes.default.bool,
  showExpandableButton: _propTypes.default.bool,
  stackTrace: _propTypes.default.string
};
PopupDialog.defaultProps = {
  expanded: false,
  expandOn: false,
  actAsExpander: false,
  showExpandableButton: false
};